import { Pipe, PipeTransform } from '@angular/core';
import { ContainService } from './contain.service';

@Pipe({
  name: 'contain'
})
export class ContainPipe implements PipeTransform {
  constructor(private service: ContainService) {}

  transform(array: any[], searchString: string, fields?: string[]): any[] {
    return this.service.instant(array, searchString, fields);
  }
}
